import {connect} from 'react-redux'

import {removeDay, updateDepartureDate} from '../planner/planner.action'
import {DayGrid} from '../daygrid/daygrid.component'
import {setCommitMsg} from '../socket/socket.action'


const mapStateToProps = (state) => {
    return {
        totalDays: state.getIn(['document', 'properties', 'totalDays']),
        departureDate: state.getIn(['document', 'properties', 'departureDate']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onRemoveDay: (index) => {
            dispatch(setCommitMsg('Deleting a day'))
            dispatch(removeDay(index))
        },
        onUpdateDeparture: (date) => {
            dispatch(setCommitMsg('Set departure date to ' + date))
            dispatch(updateDepartureDate(date))
        },
        onUpdateTotalDays: (number) => {
            dispatch(setCommitMsg('Updated total days to ' + number))
            dispatch(updateTotalDays(number))
        }
    }
}

const DayGridContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DayGrid)

export default DayGridContainer
